import React from "react";
import { IonContent, IonPage } from "@ionic/react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Uncaught error:", error, errorInfo);
    this.setState({ error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <IonPage>
          <IonContent
            className="ion-padding"
            style={{
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              height: "100%",
            }}
          >
            <div style={{ marginTop: "50px" }}>
              <h1>Something went wrong.</h1>
              <p>The application encountered an unexpected error.</p>
              <button
                onClick={() => {
                  if (window.navigator && window.navigator.serviceWorker) {
                    window.navigator.serviceWorker
                      .getRegistrations()
                      .then((registrations) => {
                        for (let registration of registrations) {
                          registration.unregister();
                        }
                        window.location.reload();
                      });
                  } else {
                    window.location.reload();
                  }
                }}
                style={{
                  padding: "10px 20px",
                  marginTop: "20px",
                  backgroundColor: "var(--main-color)",
                  color: "white",
                  borderRadius: "5px",
                  fontSize: "16px",
                }}
              >
                Reload Application
              </button>
            </div>
          </IonContent>
        </IonPage>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
